var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "nav-left-box" },
    [
      !_vm.fold
        ? _c("h1", { staticClass: "title", on: { click: _vm.toHome } }, [
            _vm._v("合美乡村")
          ])
        : _c("div", { staticClass: "el-icon-bell top-icon" }),
      _vm._v(" "),
      _c(
        "el-menu",
        {
          staticClass: "el-menu-vertical-demo",
          attrs: {
            "background-color": "#001529",
            "text-color": "#fff",
            "active-text-color": "#ffd04b",
            router: true,
            collapse: _vm.fold
          }
        },
        _vm._l(_vm.menuData, function(item, index) {
          return _c(
            "div",
            { key: index },
            [
              item.childMenus
                ? _c(
                    "el-submenu",
                    { attrs: { index: item.jump } },
                    [
                      _c("template", { slot: "title" }, [
                        _c("i", { class: item.icon }),
                        _vm._v(" "),
                        !_vm.fold
                          ? _c(
                              "span",
                              { attrs: { slot: "title" }, slot: "title" },
                              [_vm._v(_vm._s(item.title))]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm._l(item.childMenus, function(itemChild, childIndex) {
                        return _c(
                          "el-menu-item",
                          { key: childIndex, attrs: { index: itemChild.jump } },
                          [
                            _c("i", { class: itemChild.icon }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { attrs: { slot: "title" }, slot: "title" },
                              [_vm._v(_vm._s(itemChild.title))]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                : _c(
                    "el-menu-item",
                    { attrs: { index: item.jump } },
                    [
                      _c("template", { slot: "title" }, [
                        _c("i", { staticClass: "el-icon-location" }),
                        _vm._v(" "),
                        !_vm.fold
                          ? _c(
                              "span",
                              { attrs: { slot: "title" }, slot: "title" },
                              [_vm._v(_vm._s(item.title))]
                            )
                          : _vm._e()
                      ])
                    ],
                    2
                  )
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e5f08ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e5f08ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navLeft.vue
// module id = null
// module chunks = 